import React, {useState} from 'react'
import _ from "lodash";
import {DocumentArrowUpIcon} from "@heroicons/react/24/solid";
import {prepareTextListForSearch} from "../../../common/utils/text-util";
import {addPods} from "../../services/pod-data-service";
import ShowMessage from "../../../common/ui/show-message";
import ShowLink from "../../../common/ui/show-link";

const AddPodDetails = () => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [name, setInputText] = useState('');
    const [nameItemList, setNameItemList] = useState([]);

    const handleNameChange = (newValue) => {
        setInputText(newValue);

        const nameItems = _.split(newValue, '\n');
        const tempTextItemList = [];

        _.forEach(nameItems, (name, index) => {
            name = name.trim();

            if (name) {
                let displayLabel = _.startCase(name);
                let textList = prepareTextListForSearch(name);

                tempTextItemList.push({
                    name: name,
                    textList: textList,
                    displayLabel: displayLabel
                });
            }
        });

        setNameItemList(tempTextItemList);
    };

    const savePods = async () => {
        await addPods(nameItemList);
        setIsSuccess(true);
    }

    return (
        <>

            <div className="justify-center bg-gray-200 rounded dashboard-container">
                <div className="">
                    <ShowMessage
                        isSuccess={isSuccess}
                        isError={isError}
                        message={'Print On Demands Added Successfully.'}/>
                </div>

                <div className="flex justify-center bg-gray-200 rounded dashboard-container">
                    <div className="items-center justify-start w-1/2 p-8 mb-16">
                        <div className="flex justify-start items-center mb-8">
                            <ShowLink label="Back"
                                      url="/pods"/>
                            <div className="text-xl ml-4">
                                Pods
                            </div>
                        </div>
                        <textarea
                            id="name"
                            name="name"
                            value={name}
                            onChange={(event) => handleNameChange(event.target.value)}
                            className="w-full h-full border border-slate-400 rounded p-2 -mt-2"/>
                    </div>

                    <div className="items-center justify-start w-1/2 pb-16 mr-8 my-8">

                        <div className="flex items-center w-full mb-4">
                            <div className="font-bold">Prepare Pods</div>
                            <div className="ml-4">
                                <button
                                    onClick={() => {
                                        savePods()
                                    }}
                                    className="rounded flex items-center justify-center bg-green-600 text-white border border-green-600 text-gray-800 h-10 hover:bg-gray-600 hover:text-white">
                                    <div className="pl-2">
                                        <DocumentArrowUpIcon className="h-6 w-6"/>
                                    </div>
                                    <div className="p-2">Save Pods</div>
                                </button>
                            </div>
                        </div>

                        <div className="overflow-y-scroll h-full border border-gray-400 rounded bg-white px-4">
                            <div className="py-4">
                                {nameItemList?.map((textItem, index) => (
                                    <div key={index}>
                                        {index !== nameItemList?.length - 1 ?
                                            <div className="py-2 border-b border-gray-400"><span
                                                className="px-4 text-gray-600">{index + 1}</span>{textItem.displayLabel}
                                            </div>
                                            : <div className="py-2"><span
                                                className="px-4 text-gray-600">{index + 1}</span>{textItem.displayLabel}
                                            </div>
                                        }

                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </>
    )
}

export default AddPodDetails
